import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink
} from "react-router-dom";
import weather_or_not_logo from "./../weather_or_not_logo.png";

class MainMenu extends Component {
  render() {
    return (
      <header className="App-header">
        <div>
          <div className="App-logo">
            <img src={weather_or_not_logo} className="App-logo2" alt="logo" />
          </div>
          <div className="Navbar">
            <NavLink to="/" activeClassName="selected">
              <button>Add a Location</button>
            </NavLink>
            <NavLink to="/compare" activeClassName="selected">
              <button>Forecast comparisson</button>
            </NavLink>
            <NavLink to="/about" activeClassName="selected">
              <button>About this App</button>
            </NavLink>

            {/*
            <Link to="/">
              <button>Add a Location</button>
            </Link>
            <Link to="/compare">
              <button>Forecast comparisson</button>
            </Link>
            <Link to="/about">
              <button>About this App</button>
            </Link>

*/}
          </div>
        </div>
      </header>
    );
  }
}

export default MainMenu;
